<template>
    <div>
        <div class="mb-5">店铺通用敏感属性与体积配置</div>
        <el-table :data="tableList" stripe style="width: 600px">
            <el-table-column prop="date" label="敏感属性" align="center">
                <template slot="header">
                    敏感属性
                </template>
                <div slot-scope="{ row }" style="padding:5px 0;">
                    <SensitiveAttrInput v-model="row.attrObj" />
                </div>
            </el-table-column>
            <el-table-column prop="date" label="体积" width="180" align="center">
                <template slot="header">
                    体积（单位：cm）
                </template>
                <template slot-scope="{ row }">
                    <VolumeInput v-model="row.productSkuVolumeReq" />
                </template>
            </el-table-column>
            <el-table-column prop="date" label="重量" width="150" align="center">
                <template slot="header">
                    重量
                </template>
                <template slot-scope="{ row }">
                    <el-input-digit
                        v-model.number="row.productSkuWeightReq.weightValue"
                        placeholder="请输入"
                        format="#.#"
                        style="width: 90px"
                    >
                        <span>g</span>
                    </el-input-digit>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { merge } from 'lodash';
import SensitiveAttrInput from '@/components/prod/center/components/TemuInfoForm/components/FormItemSkuListExtends/SensitiveAttrInput.vue'
import VolumeInput from '@/components/prod/center/components/TemuInfoForm/components/FormItemSkuListExtends/VolumeInput.vue'
import constantConfigs from '@/components/prod/center/components/TemuInfoForm/config.js'

const defaultConfigItem = () => {
    return {
        attrObj:{
            productSkuSensitiveAttrReq:{
                isSensitive:0,
                sensitiveTypes:[],
            },
            productSkuSensitiveLimitReq:{
                maxBatteryCapacity: '',
                maxLiquidCapacity: '',
                maxKnifeLength: '',
                knifeTipAngle: { degrees: '' }
            },
        },
        productSkuVolumeReq:{
            volumeHeight:'',
            volumeLen:'',
            volumeWidth:''
        },
        productSkuWeightReq:{
            weightValue: '', // 重量值，单位g
        },
    }
}
export default {
    model: {
        prop: 'value',
        event: 'change',
    },
    components: {
        VolumeInput,
        SensitiveAttrInput,
    },
    props:{
        shopList:{
            type:Array,
            default(){
                return []
            }
        },
        value:{
            type:Object,
            default(){
                return {}
            }
        },
    },
    data(){
        return {
            ...constantConfigs,
            batchSet:{
                sensitiveData:{
                    isSensitive:0,
                    sensitiveTypes:[],
                },
                sensitiveLimitData:{
                    maxBatteryCapacity: '',
                    maxLiquidCapacity: '',
                    maxKnifeLength: '',
                    knifeTipAngle: { degrees: '' }
                },
            },
            tableList:[defaultConfigItem()],
            isInitData:false,
        }
    },
    watch:{
        value:{
            handler(v){
                if(!this.isInitData){
                    this.initData()
                }
            },
            deep:true
        },
        tableList:{
            handler(v){
                const { attrObj,...reset } = v[0]
                let obj = {
                    ...reset,
                    ...attrObj
                }
                this.$emit('change',obj)
            },
            deep:true,
        }
    },
    methods:{
        initData(){
            this.isInitData = true
            let defaultObj = defaultConfigItem()
            const { productSkuSensitiveAttrReq,productSkuSensitiveLimitReq,productSkuVolumeReq,productSkuWeightReq,...reset } = this.value
            if(productSkuSensitiveAttrReq){
                defaultObj.attrObj.productSkuSensitiveAttrReq = productSkuSensitiveAttrReq
            }
            if(productSkuSensitiveLimitReq){
                defaultObj.attrObj.productSkuSensitiveLimitReq = productSkuSensitiveLimitReq
            }
            let obj = {...defaultObj,productSkuVolumeReq,productSkuWeightReq,...reset}
            if(!productSkuVolumeReq){
                obj.productSkuVolumeReq = defaultObj.productSkuVolumeReq
            }
            if(!productSkuWeightReq){
                obj.productSkuWeightReq = defaultObj.productSkuWeightReq
            }
            this.$set(this.tableList,0,obj)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
